/* eslint-disable no-console */
import { useReducer, Reducer, ReducerState } from 'react';
// eslint-disable-next-line import/extensions
export interface FluxAction<T> {
  type: string;
  payload?: T;
}

const useReducerWrapper = <R extends Reducer<any, any>, I>(
  reducer: R,
  initialState: I & ReducerState<R>,
) => {
  let maybeLoggedReducer: Reducer<I, FluxAction<unknown>> = reducer;
  if (process.env.NODE_ENV === 'development') {
    maybeLoggedReducer = (state, action) => {
      const currState = reducer(state, action);
      console.groupCollapsed(
        `[A2B Store Action]: %c${action.type}`,
        'color:white;font-weight:bold',
      );
      console.info(
        '%cPayload:',
        'color:cyan',
        action.payload instanceof Error ? `Error<'${action.payload.message}'>` : action.payload,
      );
      console.info('%cState:', 'color:orange', currState);
      console.groupEnd();
      return currState;
    };
  }
  return useReducer(maybeLoggedReducer, initialState);
};

export default useReducerWrapper;
